import React, {useState} from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { formatDate } from '../../../../plugins/gatsby-source-vervaunt/helpers';

const HeroContainer = styled.div`
    background-color: transparent;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
`;

const Divider = styled.div`
    background-image: url(images/divider.svg);
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 150px;
    background-position: bottom;
    background-size: 100% 150px;
    background-image: url(//vervaunt.com/cms/wp-content/themes/vervaunt/img/divider.svg);
    background-repeat: no-repeat;
`;

const BackCta = styled.span`
    &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;
        height: 3px;
        background-color: #46ff46;
        transition: all .3s ease-in-out 0s;
        transform: scaleX(1);
    }
`;

interface HeroProps {
    headline: string;
    subtitle: string;
    backgroundImage: Asset;
    publishedOn: string;
    author: object;
    additionalAuthor: object;
    location: object;
}

export const HeroBlog: React.FC<HeroProps> = ({headline, subtitle, backgroundImage, publishedOn, author, additionalAuthor, location }) => {
    const [copied, setCopied] = useState(false);

    const currentLocation = location.href;
    const copy = () => {
        navigator.clipboard.writeText(currentLocation);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    };

    return (
        <HeroContainer className="relative flex items-center text-black">
            <div className="flex flex-col items-center max-w-2xl mx-auto text-center">
                <div className="pt-20">
                    <div className="pt-10 uppercase">
                        <a href="/blog/">
                            <BackCta className="relative">Back to blog home</BackCta>
                        </a>
                    </div>
                    <div className="py-10 md:pb-2 md:pt-12 md:pb-8">
                        <h1 className="max-w-2xl px-6 mx-auto mb-12 text-5xl font-semibold leading-tight md:px-0">{headline}</h1>
                        <div className="flex flex-col justify-center text-center">
                            <div className="mb-3">
                                <span className="text-base">{publishedOn ? formatDate(publishedOn) : ''}</span>
                            </div>
                        </div>
                    </div>
                    <div className={'border-black border-b flex justify-end pb-4  mx-4 sm:mx-0 sm:px-0'}>
                        <div className={'flex flex-row'}>
                            <div onClick={copy} className="flex flex-row items-center justify-center cursor-pointer">
                                {copied && <span className={'mr-2 text-sm'}>Copied!</span>}
                                <svg width="24" height="24" className={'mr-2'} xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M14.851 11.923c-.179-.641-.521-1.246-1.025-1.749-1.562-1.562-4.095-1.563-5.657 0l-4.998 4.998c-1.562 1.563-1.563 4.095 0 5.657 1.562 1.563 4.096 1.561 5.656 0l3.842-3.841.333.009c.404 0 .802-.04 1.189-.117l-4.657 4.656c-.975.976-2.255 1.464-3.535 1.464-1.28 0-2.56-.488-3.535-1.464-1.952-1.951-1.952-5.12 0-7.071l4.998-4.998c.975-.976 2.256-1.464 3.536-1.464 1.279 0 2.56.488 3.535 1.464.493.493.861 1.063 1.105 1.672l-.787.784zm-5.703.147c.178.643.521 1.25 1.026 1.756 1.562 1.563 4.096 1.561 5.656 0l4.999-4.998c1.563-1.562 1.563-4.095 0-5.657-1.562-1.562-4.095-1.563-5.657 0l-3.841 3.841-.333-.009c-.404 0-.802.04-1.189.117l4.656-4.656c.975-.976 2.256-1.464 3.536-1.464 1.279 0 2.56.488 3.535 1.464 1.951 1.951 1.951 5.119 0 7.071l-4.999 4.998c-.975.976-2.255 1.464-3.535 1.464-1.28 0-2.56-.488-3.535-1.464-.494-.495-.863-1.067-1.107-1.678l.788-.785z"/></svg>
                            </div>
                            <a href={`mailto:hi@vervaunt.com?subject=${headline}&body=${currentLocation}`}>
                                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M24 21h-24v-18h24v18zm-23-16.477v15.477h22v-15.477l-10.999 10-11.001-10zm21.089-.523h-20.176l10.088 9.171 10.088-9.171z"/></svg>
                            </a>
                        </div>
                    </div>
                    <div className={'border-black border-b pt-4 pb-8 text-left'}>
                        <p className="px-6 mb-8 uppercase md:px-0">Author{additionalAuthor !== null ? 's' : ''}</p>

                        <div className="w-full px-6 md:flex md:px-0">
                            <div className="flex-shrink-0 w-16 mx-auto">
                                <img className="block w-16 mx-auto mt-2 rounded rounded-full" src={author.image.url} alt={author.image.name} />
                            </div>
                            <div className="w-full mt-2 md:ml-8">
                                <p className="font-bold">{author.name}</p>
                                <p className="text-base">{author.bio}</p>
                            </div>
                        </div>
                        {additionalAuthor && (
                            <div className="w-full px-6 mt-8 md:mt-4 md:flex md:px-0">
                                <div className="flex-shrink-0 w-16 mx-auto">
                                    <img className="block w-16 mx-auto mt-2 rounded rounded-full" src={additionalAuthor.image.url} alt={additionalAuthor.image.name} />
                                </div>
                                <div className="w-full mt-2 md:ml-8">
                                    <p className="font-bold">{additionalAuthor.name}</p>
                                    <p className="text-base">{additionalAuthor.bio}</p>
                                </div>
                            </div>
                        )}

                    </div>
                    <p className="max-w-2xl px-6 mx-auto my-4 mt-12 text-2xl leading-tight text-left font-playfair md:px-0">{subtitle}</p>

                </div>
            </div>
        </HeroContainer>
    );
};
